import React from 'react';
import PainelUltimos3Dias from './PainelUltimos3Dias';
import PainelAcompanhamento from './PainelAcompanhamento';

function ObservabilidadeFlyshield() {
  return (
    <div>
      <PainelUltimos3Dias />
      <PainelAcompanhamento />
    </div>
  );
}

export default ObservabilidadeFlyshield;
